// example usage: normalizeString('Hello_World') => 'hello-world'
export const normalizeString = (input: string | undefined): string => {
  if (!input) {
    return ''; // Return empty string for falsy values
  }

  return input.toLowerCase().replace(/_/g, '-');
};
